// Keep this list in sync with backend/src/config/supportedLanguages.js
export const SUPPORTED_LANGUAGES = ['en', 'hi', 'ar'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

// Human-readable labels shown in dropdowns. Native names so users recognize their own language.
export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  hi: 'हिन्दी',
  ar: 'العربية',
};

// Right-to-left languages — used to set `dir="rtl"` on <html> when active.
export const RTL_LANGUAGES: readonly SupportedLanguage[] = ['ar'];

export function isRTL(lang: string | undefined | null): boolean {
  return !!lang && (RTL_LANGUAGES as readonly string[]).includes(lang);
}

// Languages that currently have at least the `common` and `admin` bundles in this build.
// Used to filter the Admin dropdown and the user picker so we don't offer half-translated locales.
export const BUNDLED_LANGUAGES: SupportedLanguage[] = ['en', 'ar'];

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}
